const EnumKFTTQuaternion = 5 // 四元数(quat<double>)类型

const EnumAPBTRotation = 2 // 旋转属性绑定

// // 四元数乘法函数
// const quatMultiply = (q1, q2) => {
//   const w1 = q1[0]; const x1 = q1[1]; const y1 = q1[2]; const z1 = q1[3]
//   const w2 = q2[0]; const x2 = q2[1]; const y2 = q2[2]; const z2 = q2[3]

//   const w = w1 * w2 - x1 * x2 - y1 * y2 - z1 * z2
//   const x = w1 * x2 + x1 * w2 + y1 * z2 - z1 * y2
//   const y = w1 * y2 - x1 * z2 + y1 * w2 + z1 * x2
//   const z = w1 * z2 + x1 * y2 - y1 * x2 + z1 * w2
//   return [w, x, y, z]
// }

// // 四元数单位化函数
// const normalizeQuaternion = (quad) => {
//   const magnitude = Math.sqrt(quad[0] * quad[0] + quad[1] * quad[1] + quad[2] * quad[2] + quad[3] * quad[3])
//   return [quad[0] / magnitude, quad[1] / magnitude, quad[2] / magnitude, quad[3] / magnitude]
// }

// const rotateVec = (vec, quad) => {
//   // 将向量转换为四元数
//   const vQuat = [0, vec[0], vec[1], vec[2]]
//   // 将四元数进行单位化
//   const quadNormalized = normalizeQuaternion(quad)
//   // 计算四元数乘法
//   const qV = quatMultiply(quadNormalized, vQuat)
//   // 计算四元数的共轭
//   const qConj = [quadNormalized[0], -quadNormalized[1], -quadNormalized[2], -quadNormalized[3]]
//   // 计算旋转后的向量
//   const vRotated = quatMultiply(qV, qConj)
//   // 返回旋转后的向量
//   return [vRotated[1], vRotated[2], vRotated[3]]
// }

/**
 * @param {xyz} name 绕着哪个轴转
 * @returns 暂时使用固定轴
 */
// const convertAxisNew = async (name, nodePtr) => {
//   let res = [0, 0, 0]
//   const mat = await player.Native.NodeProxy.globalTransform(nodePtr)
//   // const mat = Matrix4.inverse(mat1)
//   const quad = await player.Native.NodeProxy.globalRotation(nodePtr)
//   let logres = null
//   if (name === 'X') {
//     // res = [1, 0, 0]
//     res = Vec3.normalize(Matrix4.multiplyDir(mat, [1, 0, 0]))
//     logres = rotateVec([1, 0, 0], quad)
//     // res = [0.458, -0.888, 0]
//   } else if (name === 'Y') {
//     // res = [0, 1, 0]
//     // res = [0, 0, -1]
//     res = Vec3.normalize(Matrix4.multiplyDir(mat, [0, 1, 0]))
//     logres = rotateVec([0, 1, 0], quad)
//   } else if (name === 'Z') {
//     // res = [0, 0, 1]
//     // res = [0.888, 0.458, 0]
//     res = Vec3.normalize(Matrix4.multiplyDir(mat, [0, 0, 1]))
//     logres = rotateVec([0, 0, 1], quad)
//   }
//   console.log(res, logres, 'axis')
//   return res
// }
/**
 * @param {xyz} name 绕着哪个轴转
 * @returns 暂时使用固定轴
 */
const convertAxis = (name) => {
  let res = [0, 0, 0]
  if (name === 'X') {
    res = [1, 0, 0]
  } else if (name === 'Y') {
    res = [0, 1, 0]
  } else if (name === 'Z') {
    res = [0, 0, 1]
  }
  return res
}

const loadRotationAction = async (node, name, data) => {
  // 创建路径动画混合器
  const mixer = await player.Native.AnimationMixer.getMixer('rotate')
  const clip = await player.Native.AnimationClip.getClip(mixer, name)
  const action = await player.Native.AnimationAction.clipAction(mixer, clip)
  player.Native.AnimationAction.setLoop(action, data.playerMode, -1)
  const clipTrackCount = await player.Native.KeyframeTrack.trackCount(clip)
  if (clipTrackCount > 0) {
    await player.Native.KeyframeTrack.clearTrack(clip)
  }
  // 创建旋转关键帧轨道
  const trackR = await player.Native.KeyframeTrack.addTrackWithParam(clip, node, {
    name: 'trackLocalRotation',
    trackType: EnumKFTTQuaternion,
    propertyLinkType: EnumAPBTRotation,
    interpolationType: 0
  })
  // await player.Native.KeyframeTrack.keyClear(trackR)

  if (data.playerMode === 0) { // 单次旋转
    const quat1 = EulerAngle.toQuat(data.angle[0])
    player.Native.KeyframeTrack.keyAppend(trackR, 0, quat1)

    const quat2 = EulerAngle.toQuat(data.angle[1])
    player.Native.KeyframeTrack.keyAppend(trackR, data.time, quat2)
  } else if (data.playerMode === 1) { // 持续旋转
    let angle = 0
    let time = 0
    // const timeOffset = 1 / data.rotateSpeed / 60 // 传入的是r/min，转换成360度要多少秒
    const axis = convertAxis(data.axis)
    let localRotMat = null
    let localRotMatInv = null
    if (data.modeltreeQuat) {
      localRotMat = Quat.toRotationMatrix(data.modeltreeQuat.quat)
      localRotMatInv = Matrix4.inverse(localRotMat)
    }
    const trackList = []
    for (let i = 0; i < 3; i += 1) {
      // 计算当前关键帧时间
      if (i > 0) {
        time += 0.5 / (data.rotateSpeed / 60)
        angle += 180
      }
      let rotMat = Matrix4.makeRotationAxis(angle, axis)
      // 倾斜转换
      if (data.modeltreeQuat) {
        rotMat = Matrix4.multiply(Matrix4.multiply(localRotMat, rotMat), localRotMatInv)
      }
      const quat = Matrix4.decompose(rotMat).quaternion
      trackList.push(
        { keyframeTrack: trackR, time, value: quat }
      )
    }
    await player.Native.KeyframeTrack.batchKeyAppend(trackList)
  }
  // 获取动画片段控制器
  // 绑定动画片段更新通知
  // player.Native.AnimationAction.bindActionUpdate(action)
  // 设置为播放形式，0为单次，1为循环旋转
  // player.Native.AnimationAction.play(action)
  return {
    mixer,
    action,
    clip
  }
}

const batchFormRotationAction = async (nodePtr, data, tagCode) => {
  const Rpath = []
  const RTime = []
  if (data.playerMode === 0) { // 单次旋转
    const quat1 = EulerAngle.toQuat(data.angle[0])
    Rpath.push(quat1)
    RTime.push(0)

    const quat2 = EulerAngle.toQuat(data.angle[1])
    Rpath.push(quat2)
    RTime.push(data.time)
    // console.log('angel', data)
  } else if (data.playerMode === 1) { // 持续旋转
    let angle = 0
    let time = 0
    if (data.rotateSpeed) {
      const timeOffset = 1 / data.rotateSpeed / 60 // 传入的是r/min，转换成360度要多少秒
      const axis = convertAxis(data.axis)
      let localRotMat = null
      let localRotMatInv = null
      if (data.modeltreeQuat) {
        localRotMat = Quat.toRotationMatrix(data.modeltreeQuat.quat)
        localRotMatInv = Matrix4.inverse(localRotMat)
      }
      for (let i = 0; i < 11; i += 1) {
        // 计算当前关键帧时间
        if (i > 0) {
          time += timeOffset
          angle += 36
        }
        // console.log('t', angle, time, data.rotateSpeed)
        let rotMat = Matrix4.makeRotationAxis(angle, axis)
        if (data.modeltreeQuat) {
          rotMat = Matrix4.multiply(Matrix4.multiply(localRotMat, rotMat), localRotMatInv)
        }
        const quat = Matrix4.decompose(rotMat).quaternion
        Rpath.push(quat)
        RTime.push(time)
      }
    } else {
      Rpath.push(0)
      RTime.push(0)
    }
  }
  const node = {
    nodePtr,
    trackParam: {
      trackType: EnumKFTTQuaternion,
      propertyLinkType: EnumAPBTRotation
    },
    loopMode: data.playerMode,
    repetitions: -1,
    path: Rpath,
    time: RTime,
    tagCode,
  }
  return node
}

/**
 * 移动node几何轴心
 * @param {quint64} modelTreeItem modeltree指针，一般为叶子节点指针
 * @param {quint64} ptr node指针
 * @param {[x, y, z]} moveInfo 鼠标拾取的位置坐标 moveType 0为初始设置，1为渲染设置
 */
const moveAxis = async (modelTreeItem, ptr, moveInfo) => {
  // console.log(moveInfo)
  let axisOffset = []
  if (moveInfo.moveType === 0) { // 0为初始设置，需要计算包围盒并保存offset
    // 利用包围盒计算convert之后的几何中心
    const aabb = await player.Native.ModelTree.calcItemAabb(modelTreeItem)
    const aabbPos = [
      (aabb.aabb.max[0] - aabb.aabb.min[0]) / 2 + aabb.aabb.min[0],
      (aabb.aabb.max[1] - aabb.aabb.min[1]) / 2 + aabb.aabb.min[1],
      (aabb.aabb.max[2] - aabb.aabb.min[2]) / 2 + aabb.aabb.min[2]
    ]
    axisOffset = [
      moveInfo.obj.pos[0] - aabbPos[0],
      moveInfo.obj.pos[1] - aabbPos[1],
      moveInfo.obj.pos[2] - aabbPos[2],
    ]
  } else if (moveInfo.moveType === 1) { // 1为渲染设置，直接移动一个offset
    axisOffset = moveInfo.obj
  }
  if (ptr) {
    await player.Native.NodeProxy.destroyNode(ptr)
  }
  // 转换对象
  const subItemInfo = await player.Native.ModelTree.getItemInfo(modelTreeItem)
  ptr = await player.Native.ModelTree.convertToNode(modelTreeItem, false)
  if (!ptr) {
    return {
      ptr: null
    }
  }
  player.Native.ModelTree.createNodeItem(subItemInfo.parentItem, ptr, true, false)
  // 隐藏原来对象
  player.Native.ModelTree.setItemVisible(modelTreeItem, false)
  // 设置轴心
  if (axisOffset[0] !== 0 && axisOffset[1] !== 0 && axisOffset[2] !== 0) {
    player.Native.NodeProxy.moveAxis(ptr, axisOffset)
  }
  return {
    ptr,
    axisOffset
  }
}

// maxSpeedValue 最小流速
// minSpeedValue 最大流速
// minValue 最小阈值
// maxValue 最大阈值
// curValue 当前测点值
const calcRotateSpeed = (minSpeedValue, maxSpeedValue, minValue, maxValue, curValue) => {
  if (curValue <= minValue) {
    curValue = minValue
  } else if (curValue >= maxValue) {
    curValue = maxValue
  }
  const speedValue = (maxSpeedValue - minSpeedValue) / (maxValue - minValue) * (curValue - minValue) + Number(minSpeedValue)
  return speedValue
}


const calcRotateAngle = (mincoord, maxcoord, minValue, maxValue, curValue) => {
  if (curValue <= minValue) {
    curValue = minValue
  } else if (curValue >= maxValue) {
    curValue = maxValue
  }
  const curValueX = (maxcoord[0] - mincoord[0]) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord[0])
  const curValueY = (maxcoord[1] - mincoord[1]) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord[1])
  const curValueZ = (maxcoord[2] - mincoord[2]) / (maxValue - minValue) * (curValue - minValue) + Number(mincoord[2])
  return {
    curValueX, curValueY, curValueZ
  }
}

const destroyTransition = async () => {

}

export {
  loadRotationAction,
  batchFormRotationAction,
  moveAxis,
  destroyTransition,
  calcRotateSpeed,
  calcRotateAngle
}
